import { createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ApiClient from "helpers/ApiClient";
import { getToken } from "helpers/Tokens";

const initialState: any = {
  appealList: [],
  loading:false
};

export const getAppealDetails:any = createAsyncThunk<any>(
  "getAppealDetails/setAppealDetails",
  async (_, thunkAPI) => {
    try {
      let userData= getToken();
      const response = await ApiClient.get(`appeal?limit=1000&userId=${userData?.id}`);    
      return response?.data?.appeals;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const appealDetailsSlice = createSlice({
  name: "getAppealDetails",
  initialState,
  reducers: {
    setAppealDetails(state, action) {
      state.appealList = action.payload;
    },
  },
  extraReducers: {
    [getAppealDetails.pending]: (state:any) => {
      state.loading = true
    },
    [getAppealDetails.fulfilled]: (state:any, action: any) => {
      state.loading = false     
      state.appealList = action.payload;
    },
    [getAppealDetails.rejected]: (state:any) => {
      state.loading = false
    },
  },
});

export const { setAppealDetails } = appealDetailsSlice.actions;
export default appealDetailsSlice;
